import { Resource } from '../i18n';

export const it: Resource = {
  form: {
    shopSearchForm: {
      buttons: {
        submit: {
          label: 'Applica',
        },
      },
    },
  },
  misc: {
    storeName: '',
  },
  shopDetails: {
    services: {
      ACCOUNT_OPENING: 'Apertura conto gioco',
      EVENTS_TICKETS: 'Biglietteria eventi',
      GIFT_VOUCHER: 'Gift Cards, Abbonamenti, Vouchers',
      HORSE_RACING: 'Ippica',
      LOCKER: 'Locker',
      LUGGAGE_STORAGE: 'Deposito bagagli',
      PAYMENT_SERVICES: 'Pagamento bollettini, MAV, RAV, PAGOPA',
      PAYMENT_USERS: 'Prelievo conto gioco',
      PHONE_RECHARGE: 'Ricariche telefoniche',
      REFILLS: 'Ricarica conto gioco',
      SHIPPING: 'Spedizioni',
      SPORTS: 'Sports',
      SPORTS_TICKETS: 'Biglietteria sport',
      TOTOCALCIO: 'Totocalcio',
      VIRTUAL: 'Virtual',
      VISURE: 'Visure',
      title: 'Cosa troverai nel punto vendita',
      types: {
        betting: 'Scommesse',
        onlineGames: 'Gioco online',
        otherServices: 'Altri servizi',
        planetPay: 'Punto vendita servizi',
      },
    },
  },
  shopTile: {},
  shopTypes: {
    BETTING: 'Scommesse',
    ONLINE_GAMES: 'Gioco online',
    OTHER_SERVICES: 'Altri servizi',
    PLANET_PAY: 'Punto vendita servizi',
  },
  welcome: '',
};
